import Headroom from 'headroom.js';

(function ready(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}(() => {
    // headroom
    const myElement = document.querySelector('.headroom');
    const headroom = new Headroom(myElement, {
        offset: 81,
    });
    headroom.init();
}));
